import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const getFields = async (password) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/get-encryption-fields/${password}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${sessionToken}`,
    },
  });
  const data = await response.json();
  return data;
};

const deleteField = async (formData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/delete-encryption-field`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formData),
  });
  const data = await response.json();
  return data;
};

const addField = async (formData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/add-encryption-field`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formData),
  });
  const data = await response.json();
  return data;
};

export { addField, getFields, deleteField };
